<template>
  <div>
    <!-- 附加服务 -->
    <el-dialog :title="$t('message.additionalServices')" :close-on-click-modal="false"
      :visible.sync="$parent.optionsDialogVisible" width="1000px" center>
      <div class="option">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!--附加服务选择  -->
            <li class="flex15">
              {{ $t("message.additionalServiceOptions") }}
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              {{ $t("message.additionalServicesJapanese") }}
            </li>
            <!--数量  -->
            <li>
              {{ $t("message.number") }}
            </li>
            <!--实际收费标准  -->
            <li class="flex15">{{ $t("message.actualCharges") }}</li>
            <!--预计费用  -->
            <li>{{ $t("message.estimatedCost") }}(元)</li>
          </ol>
          <ul v-for="(item, index) in optionsList" :key="index" v-show="item.show">
            <!-- 附加服务选择  -->
            <li class="flex15">
              <div class="checkbox" v-if="item.edit && item.name != '配套' && item.name != '拍照'">
                <el-checkbox v-model="item.checked" @change="checkedNum"></el-checkbox>
                <div class="input">
                  <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
                </div>
              </div>
              <div class="checkbox" v-else>
                <el-checkbox v-model="item.checked" @change="checkedNum">({{ index + 1 }}) {{ item.name }}</el-checkbox>
              </div>
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              <el-input v-model="item.name_translate" size="small" onfocus="this.select()"
                :placeholder="$t('message.additionalServicesJapanese')"
                v-if="item.edit && item.name != '配套' && item.name != '拍照'"></el-input>
              <span v-else>{{ item.name_translate }}</span>
            </li>
            <!--数量  -->
            <li>
              <el-input v-model="item.num" size="small" onfocus="this.select()"
                @input="handleInput(item.num, index)"></el-input>
            </li>
            <!--实际收费标准  -->
            <li class="flex15">
              <div class="template">

                <div class="input" v-if="(item.name == '配套' || item.name == '拍照')">
                  <el-input v-model="item.price" size="small" onfocus="this.select()" type="number"></el-input>
                </div>
                <div class="input" v-else>
                  <el-input v-model="item.price" size="small" onfocus="this.select()" v-if="item.edit || isEdit"
                    type="number"></el-input>
                  <span v-else>{{ item.price }}</span>
                </div>
                {{ item.unit }}
              </div>
            </li>
            <!--预计费用  -->
            <li>
              <span class="total">
                <!-- 计算方式 当个 -->
                <span v-if="item.price_type == 0">
                  {{ item.checked ? ceil(item.price * item.num) : 0 }}</span>
                <!-- 计算方式 % -->
                <span v-else>
                  <!-- 各种状态的计算方式 -->
                  <span v-if="status == 20">
                    {{ item.checked ? ceil((NP.strip(detail.price * item.num) * (item.price / 100))) : 0 }}
                  </span>
                  <span v-else-if="status == 22">
                    {{ item.checked ? ceil((NP.strip(detail.offer_price * item.num) * (item.price / 100))) : 0 }}
                  </span>

                </span>
              </span>
              <el-button size="mini" type="success" class="dark fr"
                v-if="item.edit && item.name != '配套' && item.name != '拍照'" @click="delItem(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
          <!-- 操作 -->
          <div class="operation">
            <el-button size="mini" type="success" @click="add">
              新增自定义OPTION
            </el-button>
            <el-button type="primary" size="mini" @click="show = !show">
              {{ show ? '收起' : '查看更多OPTION' }}
            </el-button>
          </div>
          <!-- 隐藏显示 -->
          <div :class="{ isShow: show }" class="showList">
            <ul v-for="(item, index) in optionsList" :key="index" v-show="!item.show">
              <!-- 附加服务选择  -->
              <li class="flex15">
                <div class="checkbox" v-if="item.edit && item.name != '配套' && item.name != '拍照'">
                  <el-checkbox v-model="item.checked" @change="checkedNum"></el-checkbox>
                  <div class="input">
                    <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
                  </div>
                </div>
                <div class="checkbox" v-else>
                  <el-checkbox v-model="item.checked" @change="checkedNum"> {{ item.name
                  }}</el-checkbox>
                </div>
              </li>
              <!--附加服务日文  -->
              <li class="flex15">
                <el-input v-model="item.name_translate" size="small" onfocus="this.select()"
                  :placeholder="$t('message.additionalServicesJapanese')"
                  v-if="item.edit && item.name != '配套' && item.name != '拍照'"></el-input>
                <span v-else>{{ item.name_translate }}</span>
              </li>
              <!--数量  -->
              <li>
                <el-input v-model="item.num" size="small" onfocus="this.select()"
                  @input="handleInput(item.num, index)"></el-input>
              </li>
              <!--实际收费标准  -->
              <li class="flex15">
                <div class="template">
                  <div class="input" v-if="(item.name == '配套' || item.name == '拍照')">
                    <el-input v-model="item.price" size="small" onfocus="this.select()" type="number"></el-input>
                  </div>
                  <div class="input" v-else>
                    <el-input v-model="item.price" size="small" onfocus="this.select()" v-if="item.edit || isEdit"
                      type="number"></el-input>
                    <span v-else>{{ item.price }}</span>
                  </div>
                  {{ item.unit }}
                </div>
              </li>
              <!--预计费用  -->
              <li>
                <span class="total">
                  <!-- 计算方式 当个 -->
                  <span v-if="item.price_type == 0">
                    {{ item.checked ? ceil(item.price * item.num) : 0 }}</span>
                  <!-- 计算方式 % -->
                  <span v-else>
                    <!-- 各种状态的计算方式 -->
                    <span v-if="status == 20">
                      {{ item.checked ? ceil((NP.strip(detail.price * item.num) * (item.price / 100))) : 0 }}
                    </span>
                    <span v-else-if="status == 22">
                      {{ item.checked ? ceil((NP.strip(detail.offer_price * item.num) * (item.price / 100))) : 0 }}
                    </span>
                  </span>
                </span>
                <el-button size="mini" type="success" class="dark fr"
                  v-if="item.edit && item.name != '配套' && item.name != '拍照'" @click="delItem(index)">
                  {{ $t("message.delete") }}
                </el-button>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.optionsDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import NP from 'number-precision' //NP.strip 处理浮点数
export default {
  props: {
    detail: { type: Object },
    status: { type: Number },
    user_id: { type: String }
  },
  data() {
    return {
      show: false,
      NP,
      optionsList: [],
      val: "",
      userId: (JSON.parse(localStorage.getItem('japanUserRoleInfo')).id + ''),
      isEdit: false
    };
  },
  created() {

    this.isEdit = this.isAuth(712)
    let datas = {
      order_detail_id: this.detail.id,
      need_fix: 1,
      user_id: this.user_id
    }
    this.$api.orderApi.orderOptionList(datas).then((res) => {
      res.data.forEach((item, index) => {
        if (index < 9) {
          item.show = true
        } else {
          item.show = false

        }
      })
      this.optionsList = res.data;
      this.optionsList.forEach(item => {
        if (item.name != '配套' && item.name != '拍照') {
          item.edit = false
        }
        if (item.price == 0 || item.price == null) {
          item.edit = true
        }
      })
      if (this.detail.option != false && this.detail.option != null) {
        this.detail.option.forEach((item) => {
          let flag = this.optionsList.every((items) => item.name != items.name);
          if (flag) {
            this.optionsList.push(item);
          }
          this.optionsList.forEach((items) => {
            if (item.name == items.name) {
              items.num = item.num;
              items.checked = item.checked;
              items.price = item.price;
              items.show = true
            }
          });
        });
      }
    });
  },
  methods: {
    add() {
      this.optionsList.push({
        auto_calculate: 0,
        checked: false,
        edit: true,
        is_overstep: 0,
        name: "",
        name_translate: "",
        price_type: 0,
        price: "",
        num: "",
        unit: '元',
        show: true
      });
    },
    delItem(i) {
      this.optionsList.splice(i, 1);
    },
    // 保存
    save() {
      let options = [];
      for (let i = 0; i < this.optionsList.length; i++) {
        if (this.optionsList[i].checked) {
          if (this.optionsList[i].name == '') {
            return this.$message.error('option中文名称不能为空')
          }
          if (this.optionsList[i].name_translate == '') {
            return this.$message.error('option日文名称不能为空')
          }

          if (this.optionsList[i].price === '') {
            return this.$message.error(this.optionsList[i].name + 'option价格为空')
          }
          let list = this.optionsList.filter(item => item.name.trim() == this.optionsList[i].name.trim())
          //只能存在一个唯一的option中文名
          if (list.length > 1) {
            return this.$message.error('option中文名称不能一致可以加个（新）之类的，比如详细检品（新）')
          }
          if (this.optionsList[i].price_type == 1) {
            options.push(this.optionsList[i]);
          } else if (this.optionsList[i].num > 0) {
            options.push(this.optionsList[i]);
          }
        }

      }

      // 批量修改
      if (this.detail.checked) {
        this.$parent.detail.order_detail.forEach(item => {
          if (item.checked) {
            let optionCopy = JSON.parse(JSON.stringify(options))
            optionCopy.forEach(opti => {
              if (opti.checked) {
                if (this.status == 20) {
                  opti.num = item.num
                } else {
                  opti.num = item.offer_num
                }
              }
            })
            item.option = optionCopy
          }
        })
      }
      this.$parent.detail.order_detail[this.$parent.i].option = options;
      this.$parent.optionsDialogVisible = false;
      this.$parent.computationalSost();
    },
    //默认数量
    checkedNum() {
      this.optionsList.forEach(item => {
        if (item.checked) {
          item.show = true
          if (!item.num) {
            if (item.name == '拍照' || item.name == '摄影') {
              item.num = 1
            } else {
              if (this.status == 20) {
                item.num = this.detail.num
              } else if (this.status == 21) {
                item.num = this.detail.confirm_num
              } else {
                item.num = this.detail.offer_num
              }
            }
          }
        } else {
          item.num = 0

        }
      })

    },
    // 是否输入的小数
    handleInput(value, index) {
      // 使用正则表达式来判断是否输入了小数
      const regex = /^(\d+)?(\.\d{1,2})?$/;
      if (!regex.test(value)) {
        // 如果输入的不是小数，则将其设置为上一次的值
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('.', '');
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('-', '');
        this.optionsList[index].num = this.optionsList[index].num.replace(/[^\d^]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin-bottom: 20px;
  // height: 650px;
  // overflow-y: auto;

  ol {
    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex2 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}

.operation {
  margin-top: 10px;


  .el-button {
    margin-right: 220px;
  }
}

.showList {
  transition: all 0.3s;
  height: 0;
  overflow: hidden;
}

.isShow {
  height: auto;

}
</style>